import { useState } from 'react';
import styled from 'styled-components';

import { Divider, Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import service from '@/services';
import useTaxonomyStore from '@/stores/TaxonomyStore';
import { modalStyle } from '@/styles/style';
import { isEmptyString, timeOut } from '@/utils/util';

import useGlobalSearchModalAction from '../../hooks/useGlobalSearchModalAction';
import StaticSearchFilterDisplay from '../StaticSearchFilterDisplay/StaticSearchFilterDisplay';

type Props = {
  aiKeywordFilter?: string;
  keywordFilter: StructuredFilterStringNumberValueSet | null;
  dateFilter: SearchDateFilterT;
  dataFilter: StructuredFilterQueryFormatT[];
  searchResult: GlobalSearchResult;
};

const SaveAsTopicModal = (props: Props) => {
  const [title, setTitle] = useState(props.searchResult.title);
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { closeModal: closeGlobalSearchModal } = useGlobalSearchModalAction();
  const { closeModal } = useModalContext();
  const { fetchTaxonomyTopics } = useTaxonomyStore();
  const wr = useWorkspaceRouter();

  const onSaveClick = async () => {
    setIsLoading(true);
    const params: CreateSavedTopicPayload = {
      search_alias: props.searchResult.alias,
      title,
    };

    if (!isEmptyString(description)) {
      params.desc = description;
    }

    const res = await service.savedTopic.createSavedTopic(params);
    await timeOut(3000);
    setIsLoading(false);
    await closeModal();
    closeGlobalSearchModal();
    await fetchTaxonomyTopics(res.taxonomy_id);
    wr.push(`/taxonomy/${res.taxonomy_id}/topic/${res.alias}`);
  };

  return (
    <Style>
      <VFlex g={16} padding="32px 32px 24px 32px">
        <Heading type="h2" className="text-gray-700">
          Save as topic
        </Heading>
        <Typo type="body2">
          Create a new topic to track feedback for this search.
        </Typo>
      </VFlex>
      <Divider />
      <VFlex padding="24px 32px">
        <StaticSearchFilterDisplay
          title={props.searchResult.title}
          saved_rule={props.searchResult}
          editable={{
            onTitleChange: setTitle,
            onDescChange: setDescription,
          }}
        />
      </VFlex>
      <Divider />
      <Flex j="flex-end" a="center" g={8} padding="24px 32px">
        <Button variant="ghost" sizeType="l" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          variant="primary"
          sizeType="l"
          style={{ width: 150 }}
          onClick={onSaveClick}
          isLoading={isLoading}
        >
          Save
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)`
  ${modalStyle};
  width: 760px;
`;

export default SaveAsTopicModal;
